import { Tooltip } from 'antd'
import type { ReactNode } from 'react'

export const MetricsCenteredCell = ({ children }: { children: ReactNode }) => (
  <span className="metrics-cell-center">{children}</span>
)

export const TruncatedCarrierHeader = ({ label }: { label: string }) => (
  <Tooltip title={label}>
    <span className="metrics-cell-center">{label.slice(0, 3)}...</span>
  </Tooltip>
)
